module.exports = __webpack_public_path__ + "static/media/article_16_white.7c2773f9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/article_16_white.svg
// module id = 1403
// module chunks = 0